// src/store/actions/seasonsActions.js
import axios from "axios";

export const GET_SEASONS_REQUEST = "GET_SEASONS_REQUEST";
export const GET_SEASONS_SUCCESS = "GET_SEASONS_SUCCESS";
export const GET_SEASONS_FAIL = "GET_SEASONS_FAIL";

export const ADD_SEASON = "ADD_SEASON";
export const UPDATE_SEASON = "UPDATE_SEASON";
export const DELETE_SEASON = "DELETE_SEASON";

const API = process.env.REACT_APP_API_URL;

export const getSeasons = (providerId) => async (dispatch) => {
  dispatch({ type: GET_SEASONS_REQUEST });
  try {
    const res = await axios.get(`${API}/seasons/get_seasons_by_provider/${providerId}`);
    dispatch({ type: GET_SEASONS_SUCCESS, payload: res.data.data || res.data });
  } catch (error) {
    dispatch({ type: GET_SEASONS_FAIL, payload: error.message || error });
  }
};

export const addSeason = (payload) => async (dispatch) => {
  const res = await axios.post(`${API}/seasons/add_season`, payload);
  dispatch({ type: ADD_SEASON, payload: res.data.data });
};

export const updateSeason = ({ id, payload }) => async (dispatch) => {
  const res = await axios.put(`${API}/seasons/update_season/${id}`, payload);
  dispatch({ type: UPDATE_SEASON, payload: res.data.data });
};

export const deleteSeason = ({ seasonId }) => async (dispatch) => {
  const res = await axios.delete(`${API}/seasons/delete_season/${seasonId}`);
  dispatch({ type: DELETE_SEASON, payload: res.data.data });
};
